import { render, staticRenderFns } from "./VentureGrid.vue?vue&type=template&id=611eee41&scoped=true"
import script from "./VentureGrid.vue?vue&type=script&lang=js"
export * from "./VentureGrid.vue?vue&type=script&lang=js"
import style0 from "./VentureGrid.vue?vue&type=style&index=0&id=611eee41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611eee41",
  null
  
)

export default component.exports